import React from "react";
import { TID } from "../lib/testIds";

export default function Coin({ phase, result, selectedSide }) {
  // phase: "idle" | "flipping" | "settled"
  let cls = "coin";
  let style = {};
  if (phase === "idle") cls += " idle";
  if (phase === "flipping") {
    cls += " flipping";
    // 6 full turns + 0 (KARA) or 0.5 (KRUS)
    const extra = result === "KRUS" ? 180 : 0;
    style = { "--target-rot": `${360 * 6 + extra}deg` };
  }
  if (phase === "settled") {
    cls += result === "KRUS" ? " show-krus" : " show-kara";
  }

  return (
    <div className="coin-stage" data-testid={TID.coinFlipper}>
      <div className={cls} style={style}
           data-result={phase === "settled" ? result : ""}
           data-selected={selectedSide}>
        <div className="coin-face kara">
          <span className="label">KARA</span>
          <span className="sub">HEADS</span>
        </div>
        <div className="coin-face krus">
          <span className="label">KRUS</span>
          <span className="sub">TAILS</span>
        </div>
      </div>
    </div>
  );
}
